import {lazyComponent} from 'coreUtils/adapters/lazy';

const SizeSelectorFlyout = lazyComponent(() => import('./SizeSelectorFlyout'));

export {SizeSelectorFlyout as default};
